import React from "react"
import { composeSx } from "../theme/composeSx"
import { Avatar, type AvatarProps } from "@mui/material"
import { resolveViraPalette } from "../theme/resolveViraPalette"

export type ViraAvatarProps = AvatarProps & {
  name?: string
  size?: "sm" | "md" | "lg"
}

const SIZE_PX = { sm: 24, md: 32, lg: 40 } as const

function initials(name?: string) {
  if (!name) return "?"
  const parts = name.trim().split(/\s+/)
  return parts
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("")
}

export function ViraAvatar({
  name,
  size = "md",
  children,
  sx,
  ...rest
}: ViraAvatarProps) {
  const px = SIZE_PX[size]
  return (
    <Avatar
      sx={composeSx((theme) => ({
        width: px,
        height: px,
        fontSize: px * 0.4,
        fontWeight: 600,
        backgroundColor: resolveViraPalette(theme).lavender,
        color: resolveViraPalette(theme).lavenderText}), sx)}
      {...rest}
    >
      {children ?? initials(name)}
    </Avatar>
  )
}
